async function enforceQtyLimits() {
  console.log("QTY LIMIT SCRIPT RUNNING");
  const res = await fetch("/cart.js");
  const cart = await res.json();
  console.log("CART DATA:", cart);

  const limitedItemEls = document.querySelectorAll('[data-qty-limited="true"]');
  console.log("LIMITED ITEMS FOUND:", limitedItemEls.length);

  for (const el of limitedItemEls) {
    const lineKey = el.querySelector("[data-id]")?.dataset.id;
    console.log("CHECKING ITEM, KEY:", lineKey);
    if (!lineKey) continue;

    const realItem = cart.items.find((i) => i.key === lineKey);
    console.log("REAL ITEM:", realItem);

    if (realItem && realItem.quantity > 1) {
      console.log("CORRECTING QUANTITY NOW");
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: lineKey, quantity: 1 }),
      });
      location.reload();
      return;
    }
  }
}

document.addEventListener("DOMContentLoaded", enforceQtyLimits);
